import PropTypes from 'prop-types'
import React, { Component } from 'react'

import {
  CHECKBOX,
  shouldRenderAsHTML,
} from '../../utilities/FormHelperUtils'
import { isEmpty } from '../../utilities/GeneralUtils'
import { simpleTranslate } from '../../utilities/TranslationUtils'
import { ROLES } from '../../utilities/accessibility/Definitions'
import AButtonStandard from '../button/AButtonStandard'
import Cont from '../layout/Cont'
import Section, { SUB, SUB_INLINE, SUB_TOP } from '../layout/Section'
import ALink from '../link/ALink'
import AIcon, { ICONS } from '../media/icon/AIcon'
import TextBlock from '../text/TextBlock'
import AInput from './AInput'

const defaultIntlObj = {
  locale: 'en-US',
  messages: {
    'external.labels_select_all': 'Select All',
    'external.labels_deselect_all': 'Deselect All',
  },
}
/** This component is used in lieu of radio buttons or checkboxes to select an option or multiple options from a list of options

@example ../../../../docs/external/form/ButtonSelector.md */

export const SELECTOR_TYPE_BUTTONGROUP = 'buttonGroup'
export const SELECTOR_TYPE_RATING = 'rating'
export const SELECTOR_TYPE_CHECKBOX = 'checkbox'
export const TYPE_PRIMARY = ''
export const TYPE_SECONDARY = 'bsw-secondary '
export const TYPES = [TYPE_PRIMARY, TYPE_SECONDARY]
export const OPTION_TYPE_SELECTABLE = 'SELECTABLE'
export const OPTION_TYPE_UNSELECTABLE = 'UNSELECTABLE'

class ButtonSelector extends Component {
  constructor(props, context) {
    super(props, context)
    let selectedValues = []

    if (typeof this.props.selectedValues !== 'undefined') {
      selectedValues = this.props.selectedValues
    }
    this.state = { selectedValues }
  }

  componentDidUpdate(prevProps) {
    const { selectedValues } = this.props

    if (
      selectedValues !== prevProps.selectedValues &&
      typeof selectedValues !== 'undefined'
    ) {
      this.setState({
        selectedValues,
      })
    }
  }

  onClick(value) {
    const alreadySelected = this.findValueInArray(
      value,
      this.state.selectedValues,
    )
    let selectedValues = this.state.selectedValues
    if (alreadySelected && this.props.allowDeselection) {
      const index = selectedValues.indexOf(value)
      if (index > -1) {
        selectedValues.splice(index, 1)
      }
    } else {
      if (!this.props.isMultiSelect) {
        selectedValues = []
      }
      selectedValues.push(value)
    }
    this.setState({
      ...this.state,
      selectedValues,
    })
    this.props.onSelect(this.props.id, selectedValues)
  }

  onSelectAllClick() {
    const { optionsValues } = this.props
    this.setState({
      ...this.state,
      selectedValues: optionsValues,
    })
    this.props.onSelect(this.props.id, optionsValues)
  }

  onDeselectAllClick() {
    this.setState({
      ...this.state,
      selectedValues: [],
    })
    this.props.onSelect(this.props.id, [])
  }

  findValueInArray(value, valueArray) {
    let found = null
    if (
      typeof valueArray !== 'undefined' &&
      valueArray !== null &&
      valueArray.length > 0
    ) {
      for (const item of valueArray) {
        if (item === value) {
          found = item
          break
        }
      }
    }

    return found
  }

  render() {
    const {
      optionsValues,
      optionLabels,
      optionIcons,
      optionNotesUIs,
      optionTypes,
      htmlIndicators,
      label,
      labelIsHTML,
      formGroup,
      numColumns,
      style,
      help,
      cmpRef,
      type,
      isInline,
      allowsBulkSelection,
      allowsBulkDeselection,
    } = this.props
    const { selectedValues } = this.state

    let labelUI = null
    let selectUI = null
    let helpContent = null
    let labelId = null
    if (typeof label !== 'undefined' && !isEmpty(label)) {
      labelId = `${cmpRef}lbl`
      labelUI = (
        <div>
          <label id={labelId} className={'control-label'}>
            <TextBlock
              content={label}
              isHTML={shouldRenderAsHTML(label, labelIsHTML)}
            />
          </label>
        </div>
      )
    }

    const helpValue = Array.isArray(help) ? help[0] : help
    if (typeof helpValue !== 'undefined' && !isEmpty(helpValue)) {
      helpContent = <p className="form-help-block">{helpValue}</p>
    }

    const divWrapper = `btn-selection-wrapper ${type}${
      style === 'error' ? 'has-error' : ''
    }`
    const findValueInArray = this.findValueInArray.bind(this)
    const onClick = this.onClick.bind(this)
    const onSelectAllClick = this.onSelectAllClick.bind(this)
    const onDeselectAllClick = this.onDeselectAllClick.bind(this)
    let buttons

    if (!isEmpty(optionLabels)) {
      if (allowsBulkSelection || allowsBulkDeselection) {
        const needsSelect =
          allowsBulkSelection && selectedValues.length < optionsValues.length
        const needsDeselect = allowsBulkDeselection && !isEmpty(selectedValues)

        let selUI = null
        let dashUI = null
        let deselUI = null

        if (needsSelect) {
          selUI = (
            <ALink
              label={simpleTranslate(
                defaultIntlObj,
                'external.labels_select_all',
                '',
              )}
              onClick={() => onSelectAllClick()}
            />
          )
        }
        if (needsSelect && needsDeselect) {
          dashUI = ' / '
        }
        if (needsDeselect) {
          deselUI = (
            <ALink
              label={simpleTranslate(
                defaultIntlObj,
                'external.labels_deselect_all',
                '',
              )}
              onClick={() => onDeselectAllClick()}
            />
          )
        }

        selectUI = (
          <Section style={SUB_TOP}>
            {selUI}
            {dashUI}
            {deselUI}
          </Section>
        )
      }

      buttons = optionLabels.map((option, i) => {
        const className = option.key ? option.key : ''
        const optionValue = optionsValues[i]
        let isHTML = false
        if (
          htmlIndicators !== undefined &&
          htmlIndicators.length > 0 &&
          htmlIndicators[i] !== undefined
        ) {
          isHTML = htmlIndicators[i]
        }
        const labelUI = (
          <TextBlock className={''} content={option} isHTML={isHTML} />
        )
        let iconUI = null
        if (
          optionIcons !== undefined &&
          !isEmpty(optionIcons) &&
          !isEmpty(optionIcons[i])
        ) {
          iconUI = <AIcon icon={ICONS[optionIcons[i]]} padded />
        }
        const optionUI = (
          <span>
            {iconUI}
            {labelUI}
          </span>
        )
        let optionNotesUI
        if (
          optionNotesUIs !== undefined &&
          optionNotesUIs.length > 0 &&
          optionNotesUIs[i] !== undefined
        ) {
          optionNotesUI = optionNotesUIs[i]
        }
        let optionType = null
        if (
          optionTypes !== undefined &&
          optionTypes.length > 0 &&
          optionTypes[i] !== undefined
        ) {
          optionType = optionTypes[i]
        }
        const selected = findValueInArray(optionValue, selectedValues) !== null
        let buttonRef = null
        if (cmpRef !== null) {
          buttonRef = `${cmpRef}-${i}`
        }

        const Tag = isEmpty(optionNotesUI) ? 'span' : 'div'

        if (this.props.selectorType === SELECTOR_TYPE_CHECKBOX) {
          return (
            <div
              key={i}
              className={'button-selector-checkbox'}
              role={ROLES.WIDGET.CHECKBOX}
              aria-checked={selected}
            >
              <AInput
                cmpRef={buttonRef}
                label={labelUI}
                onChange={() => {
                  onClick(optionValue)
                }}
                type={CHECKBOX}
                checked={selected}
                disabled={optionType === OPTION_TYPE_UNSELECTABLE}
              />
              {optionNotesUI}
            </div>
          )
        }

        return (
          <Tag key={i} role={ROLES.WIDGET.RADIO} aria-checked={selected}>
            <AButtonStandard
              cmpDescribedBy={labelId}
              cmpRef={buttonRef}
              className={className}
              numColumns={numColumns}
              useGroupClass
              formGroupPadding={formGroup}
              formGroupMargin={formGroup}
              selected={selected}
              disabled={optionType === OPTION_TYPE_UNSELECTABLE}
              value={option}
              key={i}
              onClick={() => {
                onClick(optionValue)
              }}
            >
              {optionUI}
            </AButtonStandard>
            {optionNotesUI}
          </Tag>
        )
      })
    }

    if (this.props.selectorType === SELECTOR_TYPE_CHECKBOX) {
      return (
        <Cont>
          <Cont className={divWrapper} formGroup={!isInline} cmpRef={cmpRef}>
            {labelUI}
            <Section style={SUB_INLINE}>{selectUI}</Section>
            <Cont inline={isInline}>{buttons}</Cont>
            {helpContent}
          </Cont>
        </Cont>
      )
    }

    return (
      <Cont>
        <div
          className={divWrapper}
          data-ref={cmpRef}
          role={ROLES.WIDGET.RADIOGROUP}
        >
          {labelUI}
          <Section style={SUB}>{selectUI}</Section>
          {buttons}
          {helpContent}
        </div>
      </Cont>
    )
  }
}

ButtonSelector.defaultProps = {
  cmpRef: null,
  selectorType: SELECTOR_TYPE_BUTTONGROUP,
  type: TYPE_PRIMARY,
  isInline: true,
  allowsBulkSelection: false,
  allowsBulkDeselection: false,
  labelIsHTML: false,
}

ButtonSelector.propTypes = {
  id: PropTypes.string.isRequired,
  cmpRef: PropTypes.string,
  optionsValues: PropTypes.array.isRequired,
  optionLabels: PropTypes.array.isRequired,
  optionIcons: PropTypes.array,
  optionTypes: PropTypes.array,
  isMultiSelect: PropTypes.bool.isRequired,
  allowDeselection: PropTypes.bool.isRequired,
  selectedValues: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelIsHTML: PropTypes.bool,
  formGroup: PropTypes.bool,
  numColumns: PropTypes.number,
  style: PropTypes.string,
  help: PropTypes.array,
  optionNotesUIs: PropTypes.array,
  htmlIndicators: PropTypes.array,
  selectorType: PropTypes.string,
  isInline: PropTypes.bool,
  allowsBulkSelection: PropTypes.bool,
  allowsBulkDeselection: PropTypes.bool,
  type: PropTypes.oneOf(TYPES),
}

export default ButtonSelector
